import { Box } from '@mui/material'
import { brandFonts } from '../../styled/brand'

/**
 * The hand-drawn crosshair/compass mark, reused at multiple sizes throughout
 * the site (hero, nav, footer, section kickers, CTA background). Color is
 * driven by `currentColor`, so the parent's text color controls the stroke.
 */
export const CrosshairIcon = ({
  size = 26,
  strokeWidth = 9,
  dot = true,
}: {
  size?: number
  strokeWidth?: number
  dot?: boolean
}) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    sx={{ display: 'block', flexShrink: 0 }}
  >
    <circle cx="50" cy="50" r="28" stroke="currentColor" strokeWidth={strokeWidth} />
    <line x1="50" y1="4" x2="50" y2="26" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
    <line x1="50" y1="74" x2="50" y2="96" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
    <line x1="4" y1="50" x2="26" y2="50" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
    <line x1="74" y1="50" x2="96" y2="50" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
    {dot && <circle cx="50" cy="50" r="6" fill="currentColor" />}
  </Box>
)

/**
 * Crosshair mark + "LAST SEEN" wordmark on one line. `color` sets both the
 * icon stroke and the wordmark. Used in the hero, nav, and footer.
 */
const LogoMark = ({
  iconSize = 26,
  fontSize = 18,
  color = 'inherit',
  gap = 10,
}: {
  iconSize?: number
  fontSize?: number
  color?: string
  gap?: number
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: `${gap}px`, color }}>
    <CrosshairIcon size={iconSize} />
    <Box
      component="span"
      sx={{
        fontFamily: brandFonts.heading,
        fontWeight: 700,
        fontSize: `${fontSize}px`,
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        lineHeight: 1,
      }}
    >
      Last Seen
    </Box>
  </Box>
)

export default LogoMark
